// @ts-nocheck
import { useContext, useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import Stepper3 from "../assets/Stepper3.svg";
import { EmailOutlined, Phone } from "@material-ui/icons";
import BookingSummary from "../components/booking-summary/BookingSummary";
import { bookAppointment } from "../services/AppointmentService";
import { BookingContext } from "../providers/BookingProvider";
import { useFormik } from "formik";
import * as yup from "yup";
import { isValidRut } from "../validators/validators";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PaymentPage = () => {
  const { booking, setBooking, organization } = useContext(BookingContext);

  const history = useHistory();

  // to render a loading element
  const [loading, setLoading] = useState(false);

  // discount code
  const [discountCode, setDiscountCode] = useState(undefined);

  // formik validation schema
  const validations = yup.object({
    firstName: yup.string().required("El nombre es requerido"),
    lastName: yup.string().required("El apellido es requerido"),
    documentNumber: yup
      .string()
      .required("El RUT es requerido")
      .test("isValidRUT", "El RUT es inválido", (value) => isValidRut(value)),
    email: yup
      .string()
      .email("El correo electrónico es inválido")
      .required("El correo electrónico es requerido"),
    phone: yup.string().required("El celular es requerido"),
  });

  // formik hook
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      documentNumber: "",
      email: "",
      phone: "",
    },
    validationSchema: validations,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async () => {
    setLoading(true);

    // get customer information
    const customer = {
      firstName: formik.values.firstName,
      lastName: formik.values.lastName,
      documentNumber: formik.values.documentNumber,
      email: formik.values.email,
      phone: "+56" + formik.values.phone,
    };

    // create updated object
    const updatedBooking = { ...booking, customer: customer };

    // create appoinment on backend
    const appointmentId = await bookAppointment(updatedBooking, organization);

    // update booking
    setBooking({ ...booking, customer: customer, id: appointmentId });

    // go to confirmation appoinment
    history.push("/c/confirmarCita");
  };

  const previuousPage = () => {
    history.go(-1);
  };

  // check if apply discount based on code
  const applyDiscountCode = () => {
    // apply discount
    if (discountCode === "simpply") {
      setBooking({ ...booking, discount: booking.location.amount });
      alert("¡Descuento aplicado!");
    }
    // no apply discount
    else {
      alert("¡Código erróneo, inténtalo otra vez!");
    }
  };

  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: "#F0F2F9", paddingTop: 60, height: "100vh" }}
    >
      <Container>
        <Grid container spacing={3}>
          {!loading ? (
            <>
              <Grid item xs={12} sm={8}>
                <div
                  style={{
                    backgroundColor: "#FFF",
                    padding: "4rem",
                    borderRadius: 12,
                  }}
                >
                  {/* generla container */}
                  <Grid
                    container
                    spacing={1}
                    justify={"center"}
                    direction={"column"}
                  >
                    <Grid item md={12}>
                      <img
                        src={Stepper3}
                        style={{
                          margin: "auto",
                          display: "block",
                          marginBottom: "1rem",
                          width: "100%",
                          height: "auto",
                        }}
                        alt="stepper 3"
                      />
                    </Grid>

                    {/* grid to enter payment information */}
                    <Grid item md={12}>
                      <Typography
                        variant={"h5"}
                        component={"h2"}
                        style={{
                          marginTop: "1.5rem",
                          marginBottom: "1.5rem",
                          color: "#6A6D81",
                        }}
                      >
                        Ingresa los datos del titular del medio de pago:
                      </Typography>
                    </Grid>

                    {/* form to input payment information */}
                    <form onSubmit={formik.handleSubmit} id={"form1"}>
                      <Grid item md={9} style={{ marginBottom: "1rem" }}>
                        <TextField
                          fullWidth
                          label={"Nombre"}
                          name={"firstName"}
                          variant="outlined"
                          value={formik.values.firstName}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.firstName)}
                          helperText={formik.errors.firstName}
                        />
                      </Grid>

                      <Grid item md={9} style={{ marginBottom: "1rem" }}>
                        <TextField
                          fullWidth
                          label={"Apellido"}
                          name={"lastName"}
                          variant="outlined"
                          value={formik.values.lastName}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.lastName)}
                          helperText={formik.errors.lastName}
                        />
                      </Grid>

                      <Grid item md={9} style={{ marginBottom: "1rem" }}>
                        <TextField
                          fullWidth
                          label={"RUT"}
                          name={"documentNumber"}
                          variant="outlined"
                          onKeyUp={(event) => {
                            const completeRut = event.target.value.replace(
                              /[^0-9kK]/g,
                              ""
                            );
                            const dv = completeRut.slice(-1);
                            const rutWithOutDv = completeRut.slice(0, -1);
                            event.target.value = `${rutWithOutDv}-${dv}`;
                            formik.handleChange(event);
                          }}
                          inputProps={{ maxLength: 10 }}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.documentNumber)}
                          helperText={formik.errors.documentNumber}
                        />
                      </Grid>

                      <Grid item md={9} style={{ marginBottom: "1rem" }}>
                        <TextField
                          fullWidth
                          label={"Correo electrónico"}
                          placeholder={"Correo electrónico"}
                          name={"email"}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailOutlined
                                  style={{ color: "#597EF7" }}
                                  fontSize={"small"}
                                />
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.email)}
                          helperText={formik.errors.email}
                        />
                      </Grid>

                      <Grid item md={9} style={{ marginBottom: "1rem" }}>
                        <TextField
                          fullWidth
                          label={"N° de celular"}
                          placeholder={"987654321"}
                          name={"phone"}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Phone
                                  style={{ color: "#597EF7" }}
                                  fontSize={"small"}
                                />
                                <p>+56</p>
                              </InputAdornment>
                            ),
                          }}
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                          error={Boolean(formik.errors.phone)}
                          helperText={formik.errors.phone}
                        />
                      </Grid>

                      {/* enter discount code */}
                      <Grid item xs={12} sm={10}>
                        <Typography variant={"h5"} component={"h2"}>
                          ¿Tienes algun código de descuento? 😊
                        </Typography>

                        <TextField
                          fullWidth
                          placeholder="Aquí tu codigo de descuento"
                          variant="outlined"
                          state={discountCode}
                          onChange={(e) => setDiscountCode(e.target.value)}
                        />

                        <Button
                          variant={"contained"}
                          color={"primary"}
                          style={{ float: "right" }}
                          onClick={applyDiscountCode}
                        >
                          Validar mi código
                        </Button>
                      </Grid>
                    </form>
                  </Grid>
                </div>
              </Grid>
              {/* booking summary */}
              <Grid item xs={12} sm={3}>
                <BookingSummary />
              </Grid>
            </>
          ) : (
            // loading
            <Grid
              item
              xs={12}
              sm={8}
              style={{ display: "flex", justifyContent: "center", margin: 10 }}
            >
              <CircularProgress />
              <p style={{ marginLeft: 10 }}>Cargando...</p>
            </Grid>
          )}
        </Grid>

        <Button
          variant={"contained"}
          color={"secondary"}
          style={{ float: "left" }}
          onClick={previuousPage}
        >
          Volver
        </Button>
        <Grid item md={9} style={{ marginBottom: "1rem" }}>
          <Button
            variant={"contained"}
            color={"primary"}
            style={{ float: "right" }}
            form={"form1"}
            type={"submit"}
          >
            Ir al medio de pago
          </Button>
        </Grid>
      </Container>
    </Container>
  );
};

export default PaymentPage;
